import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Trad, Paginatore, BaseComponent, Contesto } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IDatiEconomiciListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineDatiEconomici;
    ParamAPIPagine: Dati.CParamAPIPagineDatiEconomici;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class DatiEconomiciLista extends BaseComponent<Glob.IRouteGlobaleProps, IDatiEconomiciListaState> {

    private ParametriFissi: Dati.TListaParametri = {};
    private ID_Anag: number = 0;
    private ID_FideAffidamento?: number = 0;
    private BaseLink: string = "";

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagineDatiEconomici = new Dati.CParamAPIPagineDatiEconomici();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        Param.ID_Anag = (this.props.match.params as any).ID_Anag;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si può scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
        this.ID_Anag = (this.props.match.params as any).ID_Anag;
        this.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento;
        this.state.Parametri["ID_Anag"] = this.ID_Anag.toString();
        this.BaseLink = "/anagrafica/" + this.ID_Anag;
        if (this.ID_FideAffidamento != undefined) {
            this.BaseLink += "/fideaffidamento/" + this.ID_FideAffidamento;
        }
        this.BaseLink += "/DatiEconomici/";

        if (this.ID_FideAffidamento != undefined) {
            var M = Glob.GetMenu();
            M.Main = "Affidamento";
            M.ID_MenuMain = 24;
            M.VariabiliMenu = { ["{ID_FideAffidamento}"]: this.ID_FideAffidamento.toString() };
            this.props.SetMenu(M);
        }
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [7], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_DatoEconomico", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("Data", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("AnnoBilancio", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("AnnoUnico", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("Fatturato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 5:
                                this.OnOrdinamento("ValoreProduzioneUltimoAnno", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 6:
                                this.OnOrdinamento("ValoreProduzioneAnnoPrecedente", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineDatiEconomici, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={8} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr key={dato.ID_DatoEconomico}>
                        <td data-field="ID_DatoEconomico" className="TextCenter">
                            <NavLink to={this.BaseLink + dato.ID_DatoEconomico} className="arrow">
                                {dato.ID_DatoEconomico}
                            </NavLink>
                        </td>
                        <td data-field="Data" className="TextCenter">{Trad.Trad(dato.Data)}</td>
                        <td data-field="AnnoBilancio" className="TextLeft">{dato.AnnoBilancio}</td>
                        <td data-field="AnnoUnico" className="TextRight">{dato.AnnoUnico}</td>
                        <td data-field="Fatturato" className="TextRight">{Trad.TradParam("{1-I}", [dato.Fatturato])}</td>
                        <td data-field="ValoreProduzioneUltimoAnno" className="TextRight">{Trad.TradParam("{1-I}", [dato.ValoreProduzioneUltimoAnno])}</td>
                        <td data-field="ValoreProduzioneAnnoPrecedente" className="TextRight">{Trad.TradParam("{1-I}", [dato.ValoreProduzioneAnnoPrecedente])}</td>
                        <td data-field="edit" className="TextCenter">
                            <NavLink to={this.BaseLink + dato.ID_DatoEconomico} className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" >
                                <i className="la la-edit"></i>
                            </NavLink>
                        </td>
                    </tr>
                )}
            </tbody>;
        }
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={8}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        if (!this.ControlloAutorizzazione("DatiEconomiciController")) {
            this.props.history.push("/ErroreAccesso");
        }

        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Affidamento"), "/api/FideAffidamento/Contesto?ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento, "/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento));

        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-money-bill"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Dati economici")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <NavLink to={this.BaseLink + 0} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
                <div>
                    <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                        <thead>
                            <tr className="sfondoTab">
                                <th data-field="ID_DatoEconomico" className="TextCenter">{Trad.Trad("ID")}</th>
                                <th data-field="Data" className="TextCenter">{Trad.Trad("Data")}</th>
                                <th data-field="AnnoBilancio" className="TextLeft">{Trad.Trad("Anno Bilancio")}</th>
                                <th data-field="AnnoUnico" className="TextRight">{Trad.Trad("Anno Unico")}</th>
                                <th data-field="Fatturato" className="TextRight">{Trad.Trad("Fatturato")}</th>
                                <th data-field="ValoreProduzioneUltimoAnno" className="TextRight">{Trad.Trad("Valore Produzione Ultimo Anno")}</th>
                                <th data-field="ValoreProduzioneAnnoPrecedente" className="TextRight">{Trad.Trad("Valore produzione anno precedente")}</th>
                                <th data-field="edit" className="TextCenter">{Trad.Trad("Modifica")}</th>
                            </tr>
                        </thead>
                        <ChiamaAPI Aggiornare={this.state.Aggiornare}URL="/api/DatiEconomici/Ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                </table>
            </div>
            </div>
            </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/DatiEconomiciLista.tsx